export const CampaignProductScope = {
    ALL: 'all',
    GROUP: 'group',
    SINGLE: 'single',
};
